import React from "react";
import { useSelector } from "react-redux";
import PostCard from "./PostCard";

export default function PostsReadMore() {
  // const { articles } = useSelector((state) => state.news);
  const posts = useSelector((state) =>
    state.posts?.posts
      ?.filter(
        (post) =>
          post.status === "published" &&
          post.slug !== "gioi-thieu" &&
          post.slug !== "dieu-khoan"
      )
      ?.filter((e) => e.type !== "notification")
      ?.sort((a, b) => (b.view ?? 0) - (a.view ?? 0))
  );
  return (
    <div className="container mx-auto pt-2">
      <div>
        {posts?.slice(0, 10)?.map((article) => (
          <div key={article.id} className="px-2">
            <PostCard article={article} />
          </div>
        ))}
      </div>
    </div>
  );
}
